import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { useWindowSize } from 'react-use';
const useGetCSSVariables = t0 => {
  const $ = _c(11);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? [] : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const variablesToGet = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [cssVariableValues, setCssVariableValues] = useState(t2);
  const {
    width: screenWidth
  } = useWindowSize();
  let t3;
  if ($[3] !== variablesToGet) {
    t3 = JSON.stringify(variablesToGet);
    $[3] = variablesToGet;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const variablesToGetString = t3;
  let t4;
  if ($[5] !== variablesToGet) {
    t4 = () => {
      const newValues = variablesToGet.reduce(_temp, {});
      setCssVariableValues(prevValues => {
        const hasChanged = Object.keys(newValues).some(key => newValues[key] !== prevValues[key]);
        return hasChanged ? newValues : prevValues;
      });
    };
    $[5] = variablesToGet;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== screenWidth || $[8] !== variablesToGet || $[9] !== variablesToGetString) {
    t5 = [screenWidth, variablesToGet, variablesToGetString];
    $[7] = screenWidth;
    $[8] = variablesToGet;
    $[9] = variablesToGetString;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  useEffect(t4, t5);
  return cssVariableValues;
};
export default useGetCSSVariables;
function _temp(acc, variableToGet) {
  return {
    ...acc,
    [variableToGet]: getComputedStyle(document.documentElement).getPropertyValue(variableToGet)
  };
}